export default __webpack_public_path__ + "static/cafe_36065-eba4222449c90b01509a89f768969602.png";